var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.triggers),function(trigger){return [(_vm.value === trigger.value)?_c('VChip',{key:trigger.value,attrs:{"color":trigger.color,"label":"","small":""}},[_vm._v(" "+_vm._s(trigger.name)+" ")]):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }